import { observer } from 'mobx-react';

import classNames from 'classnames';
import Head from 'next/head';

import { makeStyles } from '@bequestinc/wui';
import Paper from '@mui/material/Paper';

import BackButton from 'components/BackButton';
import Breadcrumbs from 'components/Breadcrumbs';
import NavBar from 'components/NavBar';

const useStyles = makeStyles()({
  root: {
    height: '100vh',
    overflow: 'auto',
  },
});

interface PropTypes {
  children: any;
  title: string;
  showBackButton?: boolean;
  showBreadCrumbs?: boolean;
  className?: string;
}

const Page = ({
  children,
  title,
  showBackButton,
  showBreadCrumbs,
  className: externClassName,
  ...props
}: PropTypes) => {
  const { classes } = useStyles();

  return (
    <>
      <Head>
        <title>{title} | MetLife Legal Plans</title>
      </Head>
      <NavBar />
      <Paper className={classNames(classes.root, externClassName)} role="main" {...props}>
        {showBackButton && <BackButton />}
        {showBreadCrumbs && <Breadcrumbs />}
        {children}
      </Paper>
    </>
  );
};

Page.defaultProps = {
  showBackButton: true,
  showBreadCrumbs: false,
  className: '',
};

export default observer(Page);
